import type { SiteRouter } from "replo-publisher/src/trpc/routers/site";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: siteRouter,
  client: siteClient,
  utils: siteUtils,
  options: siteOptions,
} = createTrpcRouterConfig<SiteRouter>({
  path: "site",
  queryClient: getNamespacedQueryClient("site"),
});

export { siteClient, siteRouter, siteUtils, siteOptions };
